'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.default = init;

var _helpers = require('./_helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @callback getElement
 * @param {string} selector
 * @returns {HTMLElement}
 */

/**
 * @callback getElements
 * @param {string} selector
 * @returns {HTMLElement[]}
 */

/**
 * @param {{
 *  el: HTMLElement;
 *  context: {
 *    className: string;
 *    getElement: getElement;
 *    getElements: getElements;
 *  }
 * }} params
 */
function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var els = {
    apply: context.getElement('.' + context.className + '_Apply'),
    clear: context.getElement('.' + context.className + '_Clear'),
    filters: context.getElements('.' + context.className + '_Filter'),
    reset: document.querySelector('.' + context.className + '_Reset')
  };
  var listeners = (0, _assign2.default)({}, _helpers.Listeners);
  var collectionUrl = '' + window.location.origin + el.dataset.collectionUrl;

  var initialActiveFilters = getActiveFilters();

  /** @param {HTMLElement[]} filters */
  function getActiveFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : els.filters;

    return filters.filter(function (filter) {
      var currentAttribute = filter.getAttribute('aria-current');
      return currentAttribute === 'page';
    });
  }

  /**
   * @param {string} category
   * @param {HTMLElement[]} filters
   */
  function getFiltersInCategory(category) {
    var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : els.filters;

    return filters.filter(function (filter) {
      return filter.dataset.category === category;
    });
  }

  /**
   * @param {string} category
   * @param {HTMLElement} activeFilter
   */
  function setActiveFilterInCategory(category, activeFilter) {
    var filtersForCategory = getFiltersInCategory(category, els.filters);

    filtersForCategory.forEach(function (filter) {
      filter.setAttribute('aria-current', filter === activeFilter ? 'page' : '');
    });
  }

  /**
   * @param {string} category
   * @param {HTMLElement} filter
   */
  function toggleFilterInCategory(category, filter) {
    var filterIsAlreadyActive = filter.getAttribute('aria-current') === 'page';

    if (filterIsAlreadyActive) {
      filter.setAttribute('aria-current', '');
    } else {
      setActiveFilterInCategory(category, filter);
    }
  }

  /** @param {HTMLElement[]} filters */
  function setActiveFilters(filters) {
    filters.forEach(function (filter) {
      var category = filter.dataset.category;

      setActiveFilterInCategory(category, filter);
    });
  }

  /**
   * @param {string} url
   * @param {HTMLElement[]} filters
   */
  function applyFiltersToUrl(url, filters) {
    var appliedTags = filters.map(function (filter) {
      return filter.dataset.tag;
    });

    window.location.href = url + '/' + appliedTags.join('+');
  }

  /** @param {MouseEvent} event */
  function handleFilterClick(event) {
    event.preventDefault();

    var filter = event.currentTarget;
    var category = filter.dataset.category;


    toggleFilterInCategory(category, filter);
  }

  function applyFilters() {
    applyFiltersToUrl(collectionUrl, getActiveFilters());
  }

  function clearFilters() {
    applyFiltersToUrl(collectionUrl, []);
  }

  function resetFilters() {
    setActiveFilters(initialActiveFilters);
  }

  els.filters.forEach(function (filter) {
    listeners.add(filter, 'click', handleFilterClick);
  });

  listeners.add(els.apply, 'click', applyFilters);
  if (els.clear) {
    listeners.add(els.clear, 'click', clearFilters);
  }
  listeners.add(els.reset, 'click', resetFilters);
}